import type {
	getPlayerDatabaseFacetsInput,
	getPlayerDatabaseInput,
	getPlayersInput,
	getSnipeTransferPlayerSuggestionsFacetsInput,
	getSnipeTransferPlayerSuggestionsInput,
	getTransferPlayersFacetsInput,
	readAllPlayersInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetTransferPlayers: readAllPlayersInput;
	useGetTransferPlayerSuggestions: getSnipeTransferPlayerSuggestionsInput;
	useGetTransferPlayerSuggestionsFacets: getSnipeTransferPlayerSuggestionsFacetsInput;
	useSearchPlayers: getPlayersInput;
	useCreateTransferPlayers: undefined;
	useUpdateTransferPlayer: undefined;
	useDeleteTransferPlayer: undefined;
	useDeleteTransferPlayersInBatch: undefined;
	useBatchUpdateTransferPlayers: undefined;
	useResetTransferPlayersSuccessRatio: undefined;
	useGetTransferPlayersFacets: getTransferPlayersFacetsInput;
	useGetPlayerDatabase: getPlayerDatabaseInput;
	useGetPlayerDatabaseFacets: getPlayerDatabaseFacetsInput;
	useRefreshPlayerPrices: undefined;
}

const TRANSFER_PLAYERS_SERVICE_KEYS = createReactQueryKeys<Keys>(
	"transferPlayers",
	[
		"useGetTransferPlayers",
		"useGetTransferPlayerSuggestions",
		"useGetTransferPlayerSuggestionsFacets",
		"useSearchPlayers",
		"useCreateTransferPlayers",
		"useUpdateTransferPlayer",
		"useDeleteTransferPlayer",
		"useDeleteTransferPlayersInBatch",
		"useBatchUpdateTransferPlayers",
		"useResetTransferPlayersSuccessRatio",
		"useGetTransferPlayersFacets",
		"useGetPlayerDatabase",
		"useGetPlayerDatabaseFacets",
		"useRefreshPlayerPrices",
	],
);

export { TRANSFER_PLAYERS_SERVICE_KEYS };
